import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import Download from '@/utils/Download'

const MAX_CHARS_TO_DISPLAY: number = 50 * 1024
const TRUNCATED_WARNING: string = '\n---------------------------------------------------------------------\n' +
                                  'Warning: Log was truncated, use the "Download" button to get the whole file'

@Component({
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisHook extends Vue {
    private analysisService: AnalysisService
    private hook = ''

    public async mounted() {
        if (this.$route.params.analysisId !== undefined) {
            await this.loadAnalysisHook(Number(this.$route.params.analysisId))
        }
    }

    public async downloadAnalysisHook(): Promise<void> {
        try {
            const data = await this.analysisService.downloadAnalysisHook(Number(this.$route.params.analysisId))
            Download.makeDownloadLink(data, `hook.txt`)
        } catch (e) {
            const errorMessage = `Failed to download hook: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }

    private async loadAnalysisHook(analysisId: number): Promise<void> {
        try {
            const wholeHook = await this.analysisService.getAnalysisHook(analysisId)
            if (wholeHook.length > MAX_CHARS_TO_DISPLAY) {
                this.hook = wholeHook.substring(0, MAX_CHARS_TO_DISPLAY)
                this.hook += TRUNCATED_WARNING
            } else {
                this.hook = wholeHook
            }
        } catch (e) {
            const errorMessage = `Failed to load hook: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }
}